import axios from 'axios';

export default function setupAxios(store) {
    // Request Interceptor: Add auth token and show loading indicator
    axios.interceptors.request.use(config => {
        document.getElementById("loading").style.display = "block";
        const token = store.getters['auth/accessToken'];
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        config.headers['Content-Type'] = 'application/json';
        return config;
    });

    // Response Interceptor: Handle token expiry and other errors
    axios.interceptors.response.use(
        (response) => {
            // Any status code that lie within the range of 2xx cause this function to trigger
            document.getElementById("loading").style.display = "none";
            return response;
        },
        async (error) => {
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            document.getElementById("loading").style.display = "none";
            const originalRequest = error.config;

            // Check if the error is 401 and it's not a retry request
            if (error.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true; // Mark request as a retry

                try {
                    const newAccessToken = await store.dispatch('auth/refreshToken');
                    originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    return axios(originalRequest);
                } catch (refreshError) {
                    console.error("Session expired. Logging out.", refreshError);
                    store.dispatch('auth/logout', 'Your session has expired. Please log in again.');
                    return Promise.reject(refreshError);
                }
            } else if (error.response?.status === 403) {
                alert('Permission denied');
            } else if (!error.response) {
                alert("Network error or server is not responding. Please check your connection and try again.");
            }

            return Promise.reject(error);
        }
    );
}